export default `# Drelo — Política de Privacidad (Borrador)

**Última actualización:** 23 de junio de 2026
**Responsable de los datos:** Pryma Wellness Group Inc., Delaware Corporation, File #10417420 (operando como "Drelo").

---

## 1. Qué datos recolectamos

### a) Datos de cuenta (si creas una)
Nombre, correo electrónico, contraseña (almacenada con hash).

### b) Datos de pedido
Dirección de envío (nombre, teléfono, país, provincia, ciudad, dirección, código postal), email, artículos comprados, código de descuento usado, código de referido si aplica.

### c) Datos de pago
Procesados directamente por **Stripe** — Drelo no almacena tu número de tarjeta completo.

### d) Datos de navegación y analítica
- **Meta Pixel** (Facebook/Instagram): páginas vistas, productos agregados al carrito, compras completadas — usado para medir y optimizar anuncios en Meta.
- **TikTok Pixel**: mismos eventos, usado para anuncios en TikTok.
- **Google Analytics (GA4)**: estadísticas de navegación del sitio.
- **PostHog**: analítica de producto que incluye **grabación de sesión** (cómo te mueves, das clic y haces scroll en el Sitio) para entender y mejorar la experiencia de compra. No grabamos los campos de contraseña ni de pago (estos son manejados directamente por Stripe, fuera del Sitio).

Estas herramientas pueden usar cookies o almacenamiento local en tu navegador.

## 2. Cómo usamos tus datos

- Procesar y enviar tu pedido.
- Comunicarnos contigo sobre tu compra (confirmaciones, actualizaciones de envío).
- Mejorar el Sitio mediante analítica de uso (PostHog, GA4).
- Medir y optimizar nuestras campañas publicitarias (Meta Pixel, TikTok Pixel).
- Prevenir fraude y abuso de cupones/descuentos.

## 3. Con quién compartimos datos

| Tercero | Para qué | Qué recibe |
|---|---|---|
| **CJDropshipping** (proveedor) | Cumplir y enviar tu pedido | Nombre, dirección de envío, artículos comprados |
| **Stripe** | Procesar el pago | Datos de pago necesarios para la transacción |
| **Meta, TikTok, Google** | Medición y optimización de anuncios | Eventos de navegación/compra vía pixel (no tu nombre completo ni dirección) |
| **PostHog** | Analítica de producto y grabación de sesión | Eventos de interacción con el Sitio |

No vendemos tu información personal a terceros.

## 4. Seguridad

Cifrado en tránsito (HTTPS), contraseñas con hash, pagos procesados directamente por Stripe (no tocamos ni almacenamos datos de tarjeta).

## 5. Retención de datos

Conservamos los datos de pedido mientras sea necesario para fines de soporte, garantía y obligaciones fiscales/contables. Puedes solicitar la eliminación de tu cuenta y datos personales asociados, sujeto a registros que debamos retener por ley (ej. facturación).

## 6. Tus derechos

Según tu ubicación (ej. CCPA en California, normativa de tu país), puedes solicitar acceso, corrección, eliminación o exportación de tus datos, y oponerte al uso de tus datos para publicidad dirigida. Para ejercer estos derechos, contáctanos en privacidad@drelo.shop.

## 7. Cookies y rechazo de tracking

Puedes desactivar las cookies de analítica/publicidad desde la configuración de tu navegador. Esto no impide hacer tu compra, pero puede limitar funciones de personalización.

## 8. Transferencias internacionales

Nuestros servidores (Railway, Vercel) y proveedores de analítica/pago pueden estar ubicados en Estados Unidos. Si compras desde fuera de EE.UU., tus datos serán transferidos y procesados en EE.UU.

## 9. Menores de edad

El Sitio no está dirigido a menores de 18 años.

## 10. Cambios a esta política

Podemos actualizar esta Política de Privacidad; notificaremos cambios materiales con aviso razonable.

## 11. Contacto

Pryma Wellness Group Inc. (operando como Drelo)
privacidad@drelo.shop
`;
